import * as React from "react";
import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { styles } from "./OrderDetailsView.styles";
import { useTranslation } from "react-i18next";
import { TermsView } from "../views/footer/TermsView";
import { UsersRightsView } from "../views/footer/UserRightsView";
import { PrivacyNoticeView } from "./footer/PrivacyNoticeView";
import { BlueButton } from "../components/Buttons/BlueButton";

export type AgreeType = "agreeTermsCondition" | "agreeClientLegal" | "agreePrivacyNotice"

export type IAgrees = {
    [key in AgreeType]?: boolean;
}
export interface IAcceptTermsConditionsComponentProps extends WithStyles<typeof styles> {
    agrees: IAgrees;
    handleAgree: any;
}

const AcceptTermsConditionsComponentPure: React.FunctionComponent<IAcceptTermsConditionsComponentProps> = ({ classes, agrees, handleAgree }: IAcceptTermsConditionsComponentProps) => {

    const {t} = useTranslation();

    const [openTerms, setOpenTerms] = React.useState(false);
    const [openRights, setOpenRights] = React.useState(false);
    const [openPrivacyNotice, setOpenPrivacyNotice] = React.useState(false);

    const [scrollPopWindow, setScrollPopWindow] = React.useState();

    const handleClickOpen = (scrollType) => () => {
        setOpenTerms(true);
        setScrollPopWindow(scrollType);
    };

    const handleClickOpenPrivacyNotice = (scrollType) => () => {
        setOpenPrivacyNotice(true);
        setScrollPopWindow(scrollType);
    };

    const handleClose = () => {
        setOpenTerms(false);
        setOpenRights(false);
        setOpenPrivacyNotice(false);
    };

    const termsConditionRef = React.useRef(null);
    React.useEffect(() => {
        if (openTerms) {
            const {current: descriptionElement} = termsConditionRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [openTerms]);

    const userRightsRef = React.useRef(null);
    React.useEffect(() => {
        if (openRights) {
            const {current: descriptionElement2} = userRightsRef;
            if (descriptionElement2 !== null) {
                descriptionElement2.focus();
            }
        }
    }, [openRights]);

    const privacyNoticeRef = React.useRef(null);
    React.useEffect(() => {
        if (openPrivacyNotice) {
            const {current: descriptionElement3} = privacyNoticeRef;
            if (descriptionElement3 !== null) {
                descriptionElement3.focus();
            }
        }
    }, [openPrivacyNotice]);

    return <>
        <Grid container spacing={1} direction="row">
            {agrees.agreeTermsCondition !== undefined && <Grid item xs={12} sm={4}>
                <FormControlLabel
                    control={<Checkbox checked={agrees.agreeTermsCondition} onChange={handleAgree} name="agreeTermsCondition" value="agreeTermsCondition" />}
                    label={<div><Typography variant="body2">{t("basket.readAndAccepted")}</Typography>
                        <Typography variant="body2" className={classes.link}
                        onClick={handleClickOpen("paper")}>{t("basket.termsAndConditions")}</Typography>
                    </div>}
                />
            </Grid>}
            {agrees.agreeClientLegal !== undefined && <Grid item xs={12} sm={4}>
                <FormControlLabel
                    control={<Checkbox checked={agrees.agreeClientLegal} onChange={handleAgree} name="agreeClientLegal" value="agreeClientLegal" />}
                    label={<Typography variant="body2">{t("basket.clientLegal")}</Typography>}
                />
            </Grid>}
            {agrees.agreePrivacyNotice !== undefined && <Grid item xs={12} sm={4}>
                <FormControlLabel 
                    control={<Checkbox checked={agrees.agreePrivacyNotice} onChange={handleAgree} name="agreePrivacyNotice" value="agreePrivacyNotice" />}
                    label={<div><Typography variant="body2">{t("basket.read")}</Typography>
                    <Typography variant="body2" className={classes.link}
                        onClick={handleClickOpenPrivacyNotice("paper")}>Privacy Notice *</Typography>
                    </div>}
                />
            </Grid>}
        </Grid>

        <Dialog
            open={openTerms}
            onClose={handleClose}
            scroll={scrollPopWindow}
            fullWidth
            maxWidth={"lg"}
        >
            <DialogTitle id="scroll-dialog-title">General Terms and Conditions</DialogTitle>
            <DialogContent dividers={scrollPopWindow === "paper"}>
                <DialogContentText component={"span"}
                                   id="scroll-dialog-description"
                                   ref={termsConditionRef}
                                   tabIndex={-1}
                ><TermsView />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <BlueButton
                    onClick={handleClose}
                >{t("general.close")}</BlueButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openRights}
            onClose={handleClose}
            scroll={scrollPopWindow}
            fullWidth
            maxWidth={"lg"}
        >
            <DialogTitle id="scroll-dialog-title2">{t("footer.userRights.title")}</DialogTitle>
            <DialogContent dividers={scrollPopWindow === "paper"}>
                <DialogContentText component={"span"}
                                   id="scroll-dialog-description2"
                                   ref={userRightsRef}
                                   tabIndex={-1}
                ><UsersRightsView />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <BlueButton
                    onClick={handleClose}
                >{t("general.close")}</BlueButton>
            </DialogActions>
        </Dialog>

        <Dialog
            open={openPrivacyNotice}
            onClose={handleClose}
            scroll={scrollPopWindow}
            fullWidth
            maxWidth={"lg"}
        >
            <DialogTitle id="scroll-dialog-title">{t("footer.privacy.title")}</DialogTitle>
            <DialogContent dividers={scrollPopWindow === "paper"}>
                <DialogContentText component={"span"}
                                   id="scroll-dialog-description"
                                   ref={privacyNoticeRef}
                                   tabIndex={-1}
                ><PrivacyNoticeView />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <BlueButton
                    onClick={handleClose}
                >{t("general.close")}</BlueButton>
            </DialogActions>
        </Dialog>

        </>;
};

export const AcceptTermsConditionsComponent = withStyles(styles)(AcceptTermsConditionsComponentPure);
